module.exports = __webpack_public_path__ + "media/header-sr.8097cb3f.mp4";